<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">撥入對象-{{segmentName}}</h3>
        </div>
        <div class="modal-body">
            <section class="search pb-0 mb-4">
                <div class="row">
                    <div class="col-12">
                        <form class="form">
                            <div class="input-group input-lg">
                            <div class="input">
                                <input
                                type="text"
                                name="keyowrd"
                                id="keyowrd"
                                class="form-control"
                                v-model="keyowrd"
                                placeholder="輸入服務人員姓名或收費代號進行搜尋...">
                            </div>
                            <button
                            class="btn btn-primary btn-icon"
                            type="submit"
                            @click.prevent="doSearch()">
                                <i class="icon-search i-24"></i>
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            <table class="segment-table table datatable table-striped table-bordered">
                <thead>
                    <tr>
                        <th width="60px"></th>
                        <th width="100">姓名</th>
                        <th width="110">收費代號</th>
                        <th width="120">服務件數<br>(自招/非自招)</th>
                        <th width="60" v-if="segmentName!='其他業務同仁'">人數<br>下限</th>
                        <th width="60" v-if="segmentName!='其他業務同仁'">應撥<br>人數</th>
                        <th width="60">要保<br>人數</th>
                        <th v-if="segmentName =='2年內新人'">到職日<br>-------------<br>調撥期限</th>
                        <th v-else-if="segmentName =='AFP&CFP人員'">取得資格日<br>-------------<br>調撥期限</th>
                    </tr>
                </thead>
                <tbody v-if="true">
                    <tr v-for="(d, did) in agntList" :key="`td-${did}`">
                        <td width="60px">
                            <div class="mr-0 radio radio-inline">
                                <input type="radio" name="td-item" :id="`radio-${did}`" :value="d" v-model="selection">
                                <label :for="`radio-${did}`"></label>
                            </div>
                            <!-- <div class="checkbox checkbox-inline mr-0">
                                <input type="checkbox" name="td-item" :id="`check-${did}`" value="155">
                                <label :for="`check-${did}`"></label>
                            </div> -->
                        </td>
                        <td width="100">{{ d.ceempnm }}</td>
                        <td width="110">{{d.clcno}}</td>
                        <td width="120">{{d.tmp1}} / {{d.tmp2}}</td>
                        <td width="60" v-if="segmentName!='其他業務同仁'">{{d.lower_limit}}</td>                         
                        <td width="60" v-if="segmentName!='其他業務同仁'">{{d.tmp7}}</td>
                        <td width="60" >{{d.cs_count}}</td>
                        <td  v-if="segmentName=='2年內新人'">{{d.position_date | dateFormat}}<br>{{d.tmp8 | dateFormat}}</td>
                        <td  v-else-if="segmentName=='AFP&CFP人員'">{{d.dt_ym}}<br>{{d.tmp8 | dateFormat}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                    <td colspan="7" class="empty">
                        <h3 class="text-center py-5">無客戶資料</h3>
                    </td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    </tr>
                </tbody>
            </table>
            
            <div class="row">
                <div class="col-12 text-right">
                    <a @click="$emit('close')" class="btn btn-default">取消</a>
                    <a @click="$emit('submit', selection)" class="btn btn-primary">加入</a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'DialInPersonModal',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        segmentAgntList: {
            type: Array,
            default: () => {
                return []
            },
        },
        segmentName:{
            type: String,
            default: () => {
                ''
            },   
        }             
    },
    watch: {
        open: function () {
            this.updateList()
        },
    },
    data () {
        return {
            remoteDataMsg: "資料讀取中，請稍候...",
            keyowrd: '',
            selection: [],
            agntList: [],
        }
    },
    methods: {
        doSearch () {
            // 難字 update
            this.agntList = []
            setTimeout(() => {
                this.agntList = this.segmentAgntList.filter(item => {
                    return item.ceempnm.includes(this.keyowrd) || item.clcno.includes(this.keyowrd)
                })
                this.registerHanlink()  
            }, 100);
        },
        updateList () {
            this.selection = []
            this.keyowrd = ''

            // 難字 update
            this.agntList = []
            setTimeout(() => {
                this.agntList = [...this.segmentAgntList]
                this.registerHanlink()  
            }, 100);
        },
    }
}
</script>

<style lang="scss" scoped>

.segment-table thead tr,.segment-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.segment-table tbody tr {
  height: 54px;
}

.segment-table tbody {
  display: block;
  height: 300px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

</style>